import {map} from 'rxjs/operators';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';
import {type CheckIn} from 'web-app/react/entities/common/checkin';

import CheckinFromLocation, {type PossibilitiesFromLocationResponse} from './models';

export const getPossibilitiesFromLocation = (latitude: number, longitude: number) => {
    return RESTClient.getAuthenticatedObservable('daycare/checkin/getpossibilitiesfromlocation', {
        latitude,
        longitude,
        includeDistance: true,
    }).pipe(map((response: PossibilitiesFromLocationResponse) => CheckinFromLocation.fromAPI(response)));
};

export const signOut = (childId: string) => {
    return RESTClient.postAuthenticatedObservable(`v2/children/${childId}/checkout`, {}).pipe(
        map((childCheckins: CheckIn[]) => childCheckins[0]),
    );
};
